/** Coluna da lupa: a chave que as telas usam para o detalhamento. */
export const OBRAS_LISTA_TABLE_DETAIL_KEY = "detalhamento";

/** Coluna do código da obra; no mobile ela vira a coluna "Obra" (ID + embarcação). */
export const OBRAS_LISTA_TABLE_ID_KEY = "id";

/** Coluna da embarcação; no mobile ela some e o nome entra na coluna "Obra". */
export const OBRAS_LISTA_TABLE_EMBARCACAO_KEY = "embarcacao";
